import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AssetState {
  items: any[];
  loading: boolean;
  error: string | null;
}

const initialState: AssetState = {
  items: [],
  loading: false,
  error: null,
};

const assetsSlice = createSlice({
  name: "assets",
  initialState,
  reducers: {
    fetchAssetsRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAssetsSuccess(state, action: PayloadAction<any[]>) {
      state.items = action.payload;
      state.loading = false;
    },
    fetchAssetsFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    clearAssets(state) {
      state.items = [];
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  fetchAssetsRequest,
  fetchAssetsSuccess,
  fetchAssetsFailure,
  clearAssets,
} = assetsSlice.actions;
export default assetsSlice.reducer;
